.karaoke-content__title{display:flex;font-size:4rem;margin-bottom:1.5rem}.karaoke-content__title read-speaker-button{margin-right:2.5rem}.karaoke-content__title .title{color:#0091d5}
/*# sourceMappingURL=karaoke.component-Q45WEQKV.css.map */
